<template>
  <div>
    <div id="location-map"></div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      allInfoWindows: [],
    };
  },

  props: {
    locations: Array,
  },

  computed: {
    allLocations() {
      return this.locations.filter((location) => (location.latitude !== null));
    },
  },

  mounted() {
    this.initalizeMap();
    this.setupMapMarkers();
  },

  watch: {
    locations() { this.setupMapMarkers(); },
  },

  methods: {
    async initalizeMap() {
      const position = { lat: 43.289, lng: -79.879 };
      const { Map } = await google.maps.importLibrary('maps');
      this.googleMap = new Map(document.getElementById('location-map'), {
        zoom: 11,
        center: position,
        fullscreenControl: false,
        mapId: '751b84b08f92c754',
      });
    },

    setupMapMarkers() {
      const bounds = new google.maps.LatLngBounds();

      const mapMarkers = this.allLocations.map((location) => {
        const locationMarker = this.createLocationMarker(location);
        const locationInfoWindow = this.createLocationInfoWindow(location);
        this.allInfoWindows.push(locationInfoWindow);
        bounds.extend(locationMarker.position);

        locationMarker.addListener('gmp-click', () => {
          this.closeInfoWindows(locationInfoWindow);
          locationInfoWindow.open(this.googleMap, locationMarker);
        });
        return locationMarker;
      });

      // Extend bounds if there are any markers to extend around
      if (mapMarkers.length > 0) { this.googleMap.fitBounds(bounds); }
      return mapMarkers;
    },

    createLocationMarker(location) {
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        map: this.googleMap,
      });
      return marker;
    },

    createLocationInfoWindow(location) {
      let contentString = `<div>${location.name}</div>
        <div>${location.address_line}, ${location.postal_code}</div>
        <div>${location.phone_number}</div>`;
      if (location.location_page) {
        contentString += `<a href="/locations/${location.location_page}">VIEW DETAILS</a>`;
      }
      const infoWindow = new google.maps.InfoWindow({
        content: contentString,
      });
      return infoWindow;
    },

    closeInfoWindows(openInfoWindow) {
      // Keeps only one info window open at a time
      this.allInfoWindows.map((infoWindow) => {
        if (infoWindow !== openInfoWindow) {
          infoWindow.close();
        }
        return infoWindow;
      });
    },
  },
};
</script>
<style>
  #location-map {
    height: 750px;
  }
</style>
